import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeDatasetAdapter, formatAdapts, compressionAdapts } from './file-type.dataset.adapter';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureBlobFSDataset } from 'app/model/dataset/azure-blob-fs.dataset';
import { Owned } from 'app/model/base/named';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobFSDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                folderPath: '*',
                fileName: '*',
                wildcardPath: '*',
                modifiedDatetimeStart: '*',
                modifiedDatetimeEnd: '*',
                format: formatAdapts,
                compression: compressionAdapts
            }
        }
    }
})
export class AzureBlobFSDatasetAdapter extends FileTypeDatasetAdapter<AzureBlobFSDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureBlobFSDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.AzureBlobFSDataset;
        modelDataset.type = Metamodel.modelFor(AzureBlobFSDataset).name;
        modelDataset.structure = this.columnValueToResource(dataset, dataset.columns);
        modelDataset.typeProperties = {
            ...this.formatAndCompressionValueToResource(dataset.format, dataset.compression),
            fileName: ValueAdapter.toResource(dataset, AzureBlobFSDataset.FILE_NAME),
            folderPath: ValueAdapter.toResource(dataset, AzureBlobFSDataset.FOLDER_PATH),
            wildcardPath: ValueAdapter.toResource(dataset, AzureBlobFSDataset.WILDCARD_PATH),
            modifiedDatetimeStart: ValueAdapter.toResource(dataset, AzureBlobFSDataset.MODIFID_DATETIME_START),
            modifiedDatetimeEnd: ValueAdapter.toResource(dataset, AzureBlobFSDataset.MODIFID_DATETIME_END)
        };

        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }

        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureBlobFSDataset): Promise<AzureBlobFSDataset> {
        if (!dataset) {
            dataset = AzureBlobFSDataset.MODEL.create<AzureBlobFSDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.AzureBlobFSDataset;
        if (model) {
            if (model.typeProperties != null) {
                Owned.own(dataset, 'format', this.formatResourceToValue(model.typeProperties.format));
                dataset.compression = this.compressionResourceToValue(model.typeProperties.compression);
                ValueAdapter.toModel(dataset, AzureBlobFSDataset.WILDCARD_PATH, model.typeProperties.wildcardPath);
                ValueAdapter.toModel(dataset, AzureBlobFSDataset.FILE_NAME, model.typeProperties.fileName);
                ValueAdapter.toModel(dataset, AzureBlobFSDataset.FOLDER_PATH, model.typeProperties.folderPath);
                ValueAdapter.toModel(dataset, AzureBlobFSDataset.MODIFID_DATETIME_START, model.typeProperties.modifiedDatetimeStart);
                ValueAdapter.toModel(dataset, AzureBlobFSDataset.MODIFID_DATETIME_END, model.typeProperties.modifiedDatetimeEnd);
            } else {
                this.initializeModel(dataset);
            }
            dataset.columns = this.columnResourceToValue(dataset, model.structure);
        }
        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, AzureBlobFSDataset.MODEL));
        return dataset;
    }
}
